module.exports = __webpack_public_path__ + "static/media/fa-brands-400.cccc9d29.woff2";